import { RequestOptions, Headers } from '@angular/http';
import { ManikEntityService } from '../manik-library/ManikEntityService';
import { CookieManager } from '../manik-library/ManikEntityFE';

export class ProcessMicroSite {
    public IsProcessing: boolean = false;
    public ProcessingText: string = "Processing Please Wait.";
    public Interval:any;
    constructor(public _manikEntityService: ManikEntityService) { }
    PublishMicroSite(BusinessSlug: string, PortalContext: string): void {
        const headers = new Headers();
        headers.append('BusinessSlug', BusinessSlug);
        headers.append('Context', "PROCESS.MICROSITE");
        headers.append('PortalContext', PortalContext);
        headers.append('Authorization', 'Bearer ' + CookieManager.getCookie("manikAuthToken"));
        let options = new RequestOptions({ headers: headers });

        this._manikEntityService.manikWebAPIConnectHttp("http://bizbackend.manikworks.com/smartbiz", null, options)
            .subscribe(data => {
                this.IsProcessing = false;
                clearInterval(this.Interval);
                location.reload();
            });

        this._manikEntityService.manikWebAPIConnectHttp("http://bizbackend.manikworks.com/processimg/0", null, null).subscribe(data => data);
    }

    ResetBackgrounds(BusinessSlug: string, PortalContext: string): void {
        const headers = new Headers();
        headers.append('BusinessSlug', BusinessSlug);
        headers.append('Context', "reset.to.designer.media");
        headers.append('PortalContext', PortalContext);
        headers.append('Authorization', 'Bearer ' + CookieManager.getCookie("manikAuthToken"));
        let options = new RequestOptions({ headers: headers });

        this._manikEntityService.manikWebAPIConnectHttp("http://bizbackend.manikworks.com/smartbiz", null, options)
            .subscribe(data => {
                // alert("successful !!!");
                this.PublishMicroSite(BusinessSlug, PortalContext);
            });
    }
}